import type {ScopedCommands} from '@github-ui/ui-commands'
import {type ComponentProps, createContext} from 'react'

import type {GutterActions} from './use-gutter-selection'

export const TaillightsPreviewControlsContext = createContext<{
  gutterActions: GutterActions
  commands: ComponentProps<typeof ScopedCommands>['commands']
  showLineActions: boolean
} | null>(null)
